module.exports = __webpack_public_path__ + "img/shui_1.d77f46b8.png";